import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import { authService } from '../../../services/authService';
import { AUTH_STATUS, useAuthStore } from '../../../store/authStore';

export default function AuthGuard({ children }) {
  const location = useLocation();
  const { status, setChecking, setAuthenticated, setUnauthenticated } = useAuthStore();

  useEffect(() => {
    let isMounted = true;

    const bootstrapAuth = async () => {
      setChecking();
      const resolved = await authService.resolveSession();
      if (!isMounted) return;

      if (resolved.valid) {
        setAuthenticated(resolved.session);
        return;
      }

      setUnauthenticated();
    };

    bootstrapAuth();

    return () => {
      isMounted = false;
    };
  }, [setAuthenticated, setChecking, setUnauthenticated]);

  const { email, locationId } = authService.getStoredSession();
  const loginPath = email && locationId ? `/login/${email}?locationId=${locationId}` : '/login';

  if (status === AUTH_STATUS.CHECKING) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div style={{ width: 'min(560px, 90vw)' }}>
          <Skeleton variant="rounded" height={120} sx={{ mb: 2 }} />
          <Skeleton variant="rounded" height={120} sx={{ mb: 2 }} />
          <Skeleton variant="rounded" height={120} />
        </div>
      </div>
    );
  }

  if (status === AUTH_STATUS.UNAUTHENTICATED) {
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.node.isRequired,
};
